import { motion } from 'framer-motion'
import { X, Save } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import { Input, Textarea } from '@/components/ui/Input'

export interface PartnerPaymentFormData {
  valor: number
  metodo: string
  notas: string
  dataPagamento: string
}

interface PartnerPaymentModalProps {
  open: boolean
  paymentData: PartnerPaymentFormData
  setPaymentData: (data: PartnerPaymentFormData) => void
  onClose: () => void
  onSubmit: () => void
}

export function PartnerPaymentModal({
  open,
  paymentData,
  setPaymentData,
  onClose,
  onSubmit,
}: PartnerPaymentModalProps) {
  if (!open) return null

  return (
    <div className='fixed inset-0 z-[60] flex items-center justify-center p-4'>
      <div className='absolute inset-0 bg-black/40' onClick={onClose} />
      <motion.div
        initial={{ opacity: 0, scale: 0.96 }}
        animate={{ opacity: 1, scale: 1 }}
        className='relative w-full max-w-md z-10 bg-[var(--bg-card)] border border-[var(--glass-border)] rounded-xl shadow-2xl p-5'
      >
        <div className='flex items-center justify-between mb-4'>
          <h3 className='font-semibold text-[var(--font-color-h3)]' style={{ fontSize: 'var(--font-size-h3)' }}>
            Registrar Pagamento
          </h3>
          <button onClick={onClose} className='p-1.5 rounded-md text-[var(--text-muted)] hover:text-[var(--text-primary)] hover:bg-[var(--glass-bg)] transition-colors'>
            <X size={16} />
          </button>
        </div>

        <div className='space-y-3'>
          <Input
            label='Valor do Repasse'
            type='number'
            step='0.01'
            required
            value={paymentData.valor}
            onChange={(e) => setPaymentData({ ...paymentData, valor: Number(e.target.value) })}
          />
          <div className='flex flex-col gap-1.5'>
            <label className='font-medium text-[var(--font-color-label)] uppercase tracking-wider' style={{ fontSize: 'var(--font-size-label)' }}>
              Método
            </label>
            <select
              value={paymentData.metodo}
              onChange={(e) => setPaymentData({ ...paymentData, metodo: e.target.value })}
              className='bg-[var(--glass-bg)] border border-[var(--glass-border)] text-[var(--text-primary)] rounded-md px-3 py-2 text-[13px] outline-none focus:border-[var(--brand-primary)]'
            >
              <option value='Pix'>Pix</option>
              <option value='TED'>TED</option>
              <option value='Boleto'>Boleto (Inverso)</option>
            </select>
          </div>
          <Input
            label='Data do Pagamento'
            type='date'
            value={paymentData.dataPagamento}
            onChange={(e) => setPaymentData({ ...paymentData, dataPagamento: e.target.value })}
          />
          <Textarea
            label='Notas / Referência'
            value={paymentData.notas}
            onChange={(e) => setPaymentData({ ...paymentData, notas: e.target.value })}
            placeholder='Ex: Referente a Deals de Outubro'
            rows={3}
          />
        </div>

        <div className='flex items-center justify-end gap-2 mt-4'>
          <Button variant='ghost' size='sm' onClick={onClose}>Cancelar</Button>
          <Button variant='primary' size='sm' icon={<Save size={13} />} onClick={onSubmit}>
            Confirmar Pagamento
          </Button>
        </div>
      </motion.div>
    </div>
  )
}
